import { render, staticRenderFns } from "./CASEItemBtn.vue?vue&type=template&id=cf942a2c"
import script from "./CASEItemBtn.vue?vue&type=script&lang=js"
export * from "./CASEItemBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports